/*
 * Copyright (c) RECREWT GmbH 2022.
 */

export enum GeneralJobType {
  BOOKABLE = 1,
  SCHOLASTIC_INFO,
  STUDY_INFO,
  SPECIALIZATION,
}

export enum BookableType {
  CLASSIC_TRAINING,
  COMPOUND_STUDY,
  DUAL_STUDY,
}

export interface JobGeneral {
  id: string;
  categories: number[];
  topics: number[];
  name: { en: string; de: string };
  type: number;
  parentJobId: string;
  bookableType: BookableType | null;
}

const COMPOUND_STUDY_THRESHOLD = 10000;
const DUAL_STUDY_THRESHOLD = 20000;

export function getBookableTypeFromId(typeId: number | string) {
  if (+typeId > DUAL_STUDY_THRESHOLD) {
    return BookableType.DUAL_STUDY;
  }
  if (+typeId > COMPOUND_STUDY_THRESHOLD) {
    return BookableType.COMPOUND_STUDY;
  }
  // if (job.isScholastic) {
  //   return BookableType.SCHOLASTIC_TRAINING;
  // }
  return BookableType.CLASSIC_TRAINING;
}

export function getBookableType(job: JobGeneral) {
  const id = +job.id.split('_')[0];
  return getBookableTypeFromId(id);
}
